export class Notification {
    constructor() {
    }

    notify() {
        throw new Error("You have to implement the method notify.");
    }
}